import FileOpenIcon from '@mui/icons-material/FileOpenOutlined';
import LinkIcon from '@mui/icons-material/Link';
import TransparentButton from '@/trio-ui/TransparentButton';
import { dateToMonthDayHourMeridiem } from '@/utils/format';
import EditableField from './EditableField/EditableField.component';
import * as Styles from './TechnicalValidationProject.styles';
import TechnicalDesignModal from '../TechnicalDesignModal';

export type TechnicalValidationProjectComponentProps = {
  technicalChallengeId?: string;
  createdAt?: string;
  gitlabProjectUrl?: string;
  githubProjectUrl?: string;
  videoUrl?: string;
  technicalDesignTitle?: string;
  technicalDesignContent?: string;
  technicalDesignIsOpen: boolean;
  onToggleTechnicalDesignModal: () => void;
  isAdmin: boolean;
  onUpdateGitlabUrl?: (newUrl: string) => void;
  onRefetchInterview?: () => void;
};

export default function TechnicalValidationProjectComponent({
  createdAt,
  gitlabProjectUrl,
  githubProjectUrl,
  technicalDesignTitle,
  technicalDesignContent,
  technicalDesignIsOpen,
  onToggleTechnicalDesignModal,
  videoUrl,
  isAdmin,
  onUpdateGitlabUrl,
  onRefetchInterview: _onRefetchInterview,
}: TechnicalValidationProjectComponentProps): JSX.Element {
  return (
    <>
      <Styles.Box>
        <Styles.TitleAndDateRow>
          <Styles.Title>Project</Styles.Title>
          <Styles.Date>{dateToMonthDayHourMeridiem(createdAt ?? '')}</Styles.Date>
        </Styles.TitleAndDateRow>

        <Styles.Row>
          <Styles.DataTitle>GitLab URL</Styles.DataTitle>
          <EditableField
            value={gitlabProjectUrl}
            onSave={onUpdateGitlabUrl}
            showEditButton={isAdmin}
            placeholder="Enter GitLab URL"
            linkHref={gitlabProjectUrl}
          />
        </Styles.Row>

        {isAdmin && (
          <Styles.Row>
            <Styles.DataTitle>GitHub URL</Styles.DataTitle>
            <Styles.Link target="_blank" href={githubProjectUrl}>
              <LinkIcon />
              {githubProjectUrl}
            </Styles.Link>
          </Styles.Row>
        )}

        <Styles.Row>
          <Styles.DataTitle>Technical Design</Styles.DataTitle>
          <TransparentButton
            onClick={onToggleTechnicalDesignModal}
            isBlueButton
            icon={FileOpenIcon}
          >
            Open
          </TransparentButton>
        </Styles.Row>

        <Styles.Video src={videoUrl} id="technical-validation-video-player" controls />
      </Styles.Box>

      <TechnicalDesignModal
        isOpen={technicalDesignIsOpen}
        onClose={onToggleTechnicalDesignModal}
        title={technicalDesignTitle ?? ''}
        body={technicalDesignContent ?? ''}
        isEditing={false}
      />
    </>
  );
}
